import { getSignedUrlForManualReport } from "@/features/imagings/services/medicalReportsService";
import type {
  ManualReport,
  MedicalReport,
  Report,
} from "@/features/imagings/types/reports";

/**
 * Obtiene una URL de descarga para un informe
 */
export const getReportDownloadUrl = async (report: Report): Promise<string> => {
  if (report.type === "manual") {
    const manualReport = report as ManualReport;
    return getSignedUrlForManualReport(manualReport.id, manualReport.imaging_id, 1);
  } else {
    const risReport = report as MedicalReport;
    return `https://services.viewmedonline.com/mreport/${risReport.id}/download`;
  }
};
